import _ from 'lodash'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	ClickAwayListener,
	Link,
	Stack,
} from '@mui/material'
import React, { useState } from 'react'
import { ReactComponent as Arrow } from '../../media/accordion-arrow-black.svg'

const extraCategories = (data, defaultLabel) => {
	if (_.isEmpty(data)) return []

	const categories = _.reduce(
		data,
		(prev, { categoryName }) => {
			const isExisting = !!_.find(prev, ({ categoryName: name }) => name === categoryName)
			const catToAdd = { categoryName }

			return [!isExisting && catToAdd, ...prev]
		},
		[],
	)

	return _.compact(categories)
}
const Filtering = ({ label, list, filterName }) => {
	const [open, setOpen] = useState(false)

	const handleClickAway = () => setOpen(false)
	const handleClick = () => setOpen((prev) => !prev)

	const categories = extraCategories(list, label)

	return (
		<>
			{(list && (
				<ClickAwayListener onClickAway={handleClickAway}>
					<Accordion
						expanded={open}
						onClick={handleClick}
						sx={(theme) => ({
							background: 'none',
							'& .MuiButtonBase-root': {
								alignItems: 'baseline',
								minHeight: 0,
								border: 'solid 3px black',
								p: theme.spacing(0.2, 2),

								'&.Mui-expanded': {
									minHeight: 0,
								},

								'& .MuiAccordionSummary-expandIconWrapper': {
									ml: 1,
									position: 'relative',
									top: -2,
								},

								'& .MuiAccordionSummary-content': {
									m: 0,
									fontWeight: 700,
								},
							},
							'& .MuiCollapse-root': {
								position: 'absolute',
								zIndex: 100,
							},
						})}
					>
						<AccordionSummary expandIcon={<Arrow />}>{filterName || label}</AccordionSummary>
						<AccordionDetails
							sx={(theme) => ({
								position: 'absolute',
								zIndex: 100,
								top: 10,
								left: 0,
								backgroundColor: 'white',
								border: '3px solid black',
								borderTop: 0,
								p: 0,

								'& a': {
									textDecoration: 'none',
									color: 'black',
									display: 'block',
									p: theme.spacing(1, 4),
									whiteSpace: 'nowrap',
									cursor: 'pointer',
									borderTop: '3px solid',
									textAlign: 'left',

									'&:hover': {
										color: 'secondary.main',
									},
								},
							})}
						>
							<Stack>
								{categories.map(({ categoryName }, index) => (
									<Link href={(categoryName && `#${categoryName}`) || '#'} key={index}>
										{categoryName}
									</Link>
								))}
								<Link href="">Retour</Link>
							</Stack>
						</AccordionDetails>
					</Accordion>
				</ClickAwayListener>
			)) || (
				<Button
					variant="outlined"
					sx={{
						color: 'text.primary',
						borderColor: 'text.primary',
						borderWidth: 3,
						borderRadius: 0,
						fontSize: 14,
						fontWeight: 'bold',
						textTransform: 'capitalize',
						ml: 2,

						'&:hover': {
							borderColor: 'text.primary',
							borderWidth: 3,
						},
					}}
				>
					{label}
				</Button>
			)}
		</>
	)
}

export default Filtering
